<template>
	<div>
		<form @submit.prevent="onSubmit" novalidate="" autocomplete="off">
			<div class="main-header">
				<div class="container">
					<h2 class="main-header-text">Personal Account Registration</h2>
				</div>
			</div>
			<!-- eo main header -->
			<div class="main-section mgt-40">
				<div class="container">
					<div class="main-card">
						<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />
						<div class="main-card-header">
							<h2>Welcome</h2>
							<p>Sign Up. It's free!</p>
						</div>
						<!-- eo form card -->

						<div class="form-card">
							<div class="form-card-header">
								<h3><b>What's Your Phone Number?</b></h3>
							</div>

							<div class="form-card-forms">

								<div class="row">

									<div class="col-lg-12">
										<div class="form-group">

											<div class="col-lg-4">
												<div class="input-group">
													<div class="input-group-prepend">
														<span class="input-group-text"
															style="background-color: #e9ecef !important;"><img
																width="50"
																src="/static/img/passphrase/my.svg"><span>+60
															</span></span>
													</div>

													<!-- <input type="text" class="form-control" id="mobileContact"
														style="padding-left: 110px !important;"
														placeholder="Enter Phone Number" v-only-numeric=""
														name="mobileContact" autocomplete="off"
														v-model="vModel.MobileContact" data-vv-as='Phone Number'
														v-validate="'required|max:10|min:9'"
														:class="{'input': true, 'is-danger': errors.has('mobileContact') }" /> -->
														<input type="number" class="form-control" id="mobileContact"
														style="padding-left: 110px !important;"
														placeholder="Enter Phone Number" 
														name="mobileContact" autocomplete="off"
														v-model="vModel.MobileContact"
														@keydown="ValidateMobile"
														v-validate="'required'"
														:class="{'input': true, 'is-danger': errors.has('mobileContact') }" />
												</div>

												<div v-show="errors.has('mobileContact')" class="help is-danger">
													{{ errors.first('mobileContact') }}
												</div>
												<div v-show="!errors.has('mobileContact') && ShowMobileErrorMsg" class="help is-danger">
															Invalid Phone Number</div>
											</div>
											<div class="col-lg-6">
												<div style="color:grey;">
													<small>An OTP will be sent to your mobile number for
														verification</small>
												</div>
											</div>
										</div>
									</div>
								</div>

							</div>
						</div>
						<div class="form-card">
							<div class="form-card-header">
								<h3><b>Create Your Password</b></h3>
							</div>

							<div class="form-card-forms create_pass">


								<password-input :inputplaceholder="'Create Password'" v-model="vModel.Password"
									v-validate="{required : true, validatePasswordUpdated : true}" :position="'right'"
									:inputname="'Password'"
									:inputclass="{'form-control input': true, 'is-danger': errors.has('Password') }"
									name="Password" autocomplete="off"></password-input>

								<div v-show="errors.has('Password')" class=" create_pass_error help is-danger password-validation-position">
									{{ errors.first('Password') }}
								</div>



								<!-- eo form card forms -->
							</div>
						</div>
						<div class="form-card">
							<div class="form-card-header">
								<h3><b>Email Identification&nbsp;<i>(Optional)</i></b></h3>
							</div>
							<div class="form-card-forms">

								<div class="row">
									<div class="col-lg-12">
										<div class="form-group">
											<div class="col-lg-12">
												<label for="" style="color:grey;"><small>Stay upto date with
														our latest
														promotions,
														notifications and transaction summary by entering
														your email below which you can also use to login for future
														transactions</small>
												</label>
											</div>
											<div class="col-lg-4">
												<input type="email" class="form-control" id="email" name="email"
													placeholder="Enter Email Address" data-vv-name="email"
													autocomplete="off" v-model="vModel.Email" data-vv-as='Email Address'
													v-validate="'email'"
													:class="{'input': true, 'is-danger': errors.has('email') }" />
												<div v-show="errors.has('email')" class="help is-danger">
													{{ errors.first('email') }}
												</div>
											</div>
											<div class="col-lg-6">
												<div style="color:grey;">
													<small>An email validation link will be sent to your email for
														verification</small>
												</div>
											</div>

										</div>
									</div>
								</div>
							</div>
							<!-- eo form card forms -->
						</div>

						<div class="form-card">
							<div class="form-card-header">
								<h3><b>Security Check</b></h3>
							</div>

							<div class="form-card-forms">
								<div class="row">
									<div class="col-lg-12" style="padding-left: 30px;">
										<vue-recaptcha ref="recaptcha" @verify="onVerify" @expired="onExpired"											
											sitekey="6LdUWJYUAAAAAHRLaOQKE_LcLpO_9eWdLtzGeSh7"
											v-model="vModel.ReCaptcha">
										</vue-recaptcha>
									</div>
								</div>
							</div>
							<!-- eo form card forms -->
						</div>

						<div class="submit-forms text-center">
							<div class="detail">
								<p>
									By clicking "Register", I confirm that I have read the <a href="https://www.eremit.com.my/privacy/personal"
																		target="_blank" style="color:#ff0000">
																		Terms and
																		Conditions
																	</a> and <a
										href="https://mtradeasia.com/main/privacy-policy/" target="_blank" style="color:#ff0000">Privacy Policy</a>
								</p>
							</div>

							<button class="btn submit-form">Register</button>
						</div>
						<!-- eo form card -->
					</div>
					<!-- eo form card forms -->
				</div>
				<!-- eo form card -->
			</div>
			<!-- eo main card -->
			<!-- eo container -->
		</form>
	</div>

</template>

<script>

	import PasswordInput from "../../shared/PasswordInputNew";
	import VueRecaptcha from "vue-recaptcha";
	import welcome from '../../shared/Welcome.vue'
	import commonService from "../../services/common";

	export default {
		name: "registration",
		inject: ['$validator'],
		components: {
			PasswordInput,
			VueRecaptcha,
			welcome
		},

		computed: {

			fullname: function () {
				if (this.vModel.FirstName == null) this.vModel.FirstName = "";

				if (this.vModel.MiddleName == null) this.vModel.MiddleName = "";

				if (this.vModel.LastName == null) this.vModel.LastName = "";

				return (
					this.vModel.FirstName.trim() +
					this.vModel.MiddleName.trim() +
					this.vModel.LastName.trim()
				);
			}
		},
		beforeRouteEnter(to, from, next) {
			var promises = [];
			Promise.all(promises).then(response => {
				next(p => {
					if (commonService.getStorage("socialLoginDetail")) { // if redirected from social login
						var socialLoginDetail = JSON.parse(commonService.getStorage('socialLoginDetail'));
						p.vModel.FirstName = socialLoginDetail.FirstName;
						p.vModel.MiddleName = socialLoginDetail.MiddleName;
						p.vModel.LastName = socialLoginDetail.LastName;
						p.vModel.Email = socialLoginDetail.Email;
						p.vModel.SocialAppId = socialLoginDetail.AppId;
						p.vModel.SocialNetwork = socialLoginDetail.Network;
						p.vModel.SocialEmail = socialLoginDetail.Email;
					}

					p.vModel.IsReferred = to.params.referralcode != undefined;
					p.vModel.ReferralCode = to.params.referralcode == undefined ? '' : to.params.referralcode


				});

				commonService.destroyStorage();
			});
		},
		data() {
			return {
				vModel: this.onreset(),
				DefaultCountries: null,
				siteKey: "6LfwDt0UAAAAAHF4zPrB2dePYLxUmGMl840ThRI9",
				ShowMobileErrorMsg: false
			};
		},
		methods: {
			onreset: function () {
				return {
					Id: '00000000-0000-0000-0000-000000000000',
					FirstName: "",
					MiddleName: "",
					LastName: "",
					HomeContact: "",
					MobileContact: "",
					WorkContact: "",
					Email: null,
					Password: "",
					ConfirmPassword: "",
					ReCaptcha: null,
					ReferralCode: "",
					IsReferred: false,
					SocialAppId: null,
					SocialNetwork: null,
					SocialEmail: null,
					tabIndex: 0
				}
			},
			onVerify: function (response) {
				this.vModel.ReCaptcha = response;
			},
			onExpired: function () {
				this.resetRecaptcha()
			},
			resetRecaptcha() {
				this.$refs.recaptcha.reset() // Direct call reset method
			},
			onClearForm: function () {
				this.vModel = this.onreset();
				setTimeout(() => {
					this.$validator.reset();
					this.errors.clear();
				}, 100)
				this.resetRecaptcha();
			},
			onSubmit: function () {
				var self = this;
				if (self.vModel.MobileContact.length < 9) return false;
				if (self.isProcessing) return false;
				self.$validator.validateAll().then(result => {
					if (result && self.beforeSave()) {
						self.isProcessing = true;
						ga('send', 'event', 'Button', 'Click', 'Register');
						var model = Object.assign({}, self.vModel);
						model.MobileContact = "60" + model.MobileContact;
						self.$http.post("account/register/add", model).then(
							response => {
								self.isProcessing = false;
								commonService.removeStorage('socialLoginDetail');
								commonService.setStorage("RegistrationMobileNumber", model.MobileContact);
								self.$router.push("/account/registration/phoneconfirm/" + response.body.OtpId);

							},
							error => {
								self.isProcessing = false;
								self.resetRecaptcha();
								self.vModel.ReCaptcha = null;
							}
						);
					}
				});
			},

			beforeSave() {
				if (!this.vModel.ReCaptcha) {
					this.$toastr("error", "Please perform Security Check.");
					return false;
				}
				return true;
			},

			ValidateMobile(event){
				var keyCode = event.keyCode ? event.keyCode : event.which;
				if ((!(keyCode > 93 && keyCode < 106) && (keyCode < 48 || keyCode > 57)) ||  this.vModel.MobileContact.length > 9) {					
					event.preventDefault();
				}
				if(keyCode === 8){
					//on backspace
					this.vModel.MobileContact = this.vModel.MobileContact.slice(0,-1);
					if(this.vModel.MobileContact.length < 9){
						this.ShowMobileErrorMsg = true;
					}
				}else{
					var len = this.vModel.MobileContact === undefined ? 0 : this.vModel.MobileContact.length;
					if(len < 8){
						this.ShowMobileErrorMsg = true;
					}else{
						this.ShowMobileErrorMsg = false;
					}
				}
			}

		}
	};
</script>
<style scoped>
.password-validation-position{
	padding-left: 15px;
	margin-top: -40px !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>